import { render, staticRenderFns } from "./ECDSettings.vue?vue&type=template&id=260e05f4&"
import script from "./ECDSettings.vue?vue&type=script&lang=js&"
export * from "./ECDSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports